module.exports = __webpack_public_path__ + "media/img/events/bg/interview-b88dcbf78266045028552093a5554096.jpg";